export default "__VITE_ASSET__Chsxss54__"